var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_546)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_398_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5079 7.48206C15.0445 8.01534 12 10.0696 11.5341 12.9133C10.8258 12.6726 10.0737 12.5889 9.32981 12.668C8.58594 12.7471 7.86819 12.9871 7.22637 13.3713C6.58455 13.7556 6.03402 14.2749 5.61299 14.8932C5.19196 15.5115 4.91051 16.2141 4.78817 16.9521C4.66583 17.69 4.70554 18.4458 4.90453 19.1669C5.10352 19.888 5.45703 20.5572 5.94053 21.128C6.42403 21.6988 7.02594 22.1576 7.7045 22.4725C8.38305 22.7874 9.12199 22.9508 9.87005 22.9516H19.2451C20.8026 22.9503 22.3257 22.4931 23.6263 21.6363C24.927 20.7794 25.9483 19.5605 26.5643 18.13C27.1802 16.6994 27.3639 15.1198 27.0925 13.5861C26.8211 12.0524 26.1066 10.6318 25.0372 9.49942C23.9678 8.36708 22.5902 7.57264 21.0745 7.21415C19.5588 6.85565 17.9713 6.94879 16.5079 7.48206Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.963867)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_398_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.963867 0.13208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.a43b313aeaa8243eac06a17b6b08e2a4.svg";
export { ForwardRef as ReactComponent };